import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const customPreset = definePreset(Aura, {
  //Your customizations, see the following sections for examples
  semantic: {
    colorScheme: {
      light: {
        primary: {
          color: 'var(--primary)',
          contrastColor: '#ffffff',
          hoverColor: 'var(--primary-light)',
          activeColor: 'var(--primary-dark)',
        },
        //     secondary: {
        //       color: 'var(--secondary)',
        //       contrastColor: '#ffffff',
        //       hoverColor: 'var(--secondary-light)',
        //       activeColor: 'var(--secondary-dark)',
        //     },
      },
    },
  },
});

export default customPreset;
